import { t } from "@lingui/macro";
import {
    FileTextOutlined, HddOutlined, InboxOutlined, UserOutlined, WhatsAppOutlined, ShopOutlined,
    PercentageOutlined, DollarOutlined,
} from '@ant-design/icons';
import React from 'react';
import { PlanType } from "bukku/enums/PlanType";
import { AddonPackType } from "bukku/enums/AddonPackType";

/**
 * @type {Object.<AddonPackType, {
 *      name: string,
 *      icon: React.ReactNode,
 *      min: number,
 *      max: number,
 *      incrementStep: number | bytes,
 *      unit: string,
 *      showBillingCycle: boolean, // show billing cycle (eg: / month) in the toggler
 *      hideInPlans: PlanType[],
 * }>}
 */
export const AddonTogglerInfo = {
    [AddonPackType.USER]: {
        name: "User",
        icon: <UserOutlined />,
        min: 0,
        max: 60, // 300 users
        // incrementStep: 5,
        unit: t`users`,
        showBillingCycle: false,
        hideInPlans: [
            PlanType.PREMIUM, PlanType.BASE_2025,
            PlanType.LAUNCH_2025, PlanType.SEED_2025, PlanType.GROW_2025,
            PlanType.PRIME_2025, PlanType.ELITE_2025,
        ],
    },
    [AddonPackType.DATA_EXTRACTION]: {
        name: "Data Extraction",
        icon: <FileTextOutlined />,
        min: 0,
        max: 60, // 30000 pages
        // incrementStep: 500,
        unit: t`pages`,
        showBillingCycle: true,
        hideInPlans: [PlanType.LAUNCH, PlanType.LAUNCH_2025, PlanType.ZERO, PlanType.ONE, PlanType.TWO],
    },
    [AddonPackType.WHATSAPP]: {
        name: "WhatsApp",
        icon: <WhatsAppOutlined />,
        min: 0,
        max: 60, // 6000 files
        // incrementStep: 100,
        unit: t`files`,
        showBillingCycle: true,
        hideInPlans: [PlanType.ZERO, PlanType.ONE, PlanType.TWO, PlanType.LAUNCH],
    },
    [AddonPackType.EMAIL]: {
        name: "Email",
        icon: <InboxOutlined />,
        min: 0,
        max: 60, // 300000 emails
        // incrementStep: 5000,
        unit: t`emails`,
        showBillingCycle: true,
        hideInPlans: [PlanType.ZERO, PlanType.ONE, PlanType.TWO, PlanType.BASE_2025],
    },
    [AddonPackType.STORAGE]: {
        name: "Storage",
        icon: <HddOutlined />,
        min: 0,
        max: 60, // 300 GB
        // incrementStep: 5,
        // incrementStep: 5 * ONE_GB_IN_BYTES;
        unit: t`GB`,
        showBillingCycle: false,
        hideInPlans: [],
    },
    [AddonPackType.FLOW]: {
        name: "Flow",
        icon: <ShopOutlined />,
        min: 0,
        max: 60, // 60 * 2000 flow orders = 120000
        // incrementStep: 5,
        // incrementStep: 5 * ONE_GB_IN_BYTES;
        unit: t`orders`,
        showBillingCycle: true,
        hideInPlans: [PlanType.BASE_2025],
    },
    [AddonPackType.MALAYSIA_SST]: {
        name: "Malaysia SST",
        icon: <PercentageOutlined />,
        min: 0,
        max: 1,
        unit: t`unit`,
        showBillingCycle: false,
        hideInPlans: [PlanType.LAUNCH_2025, PlanType.PRIME_2025, PlanType.ELITE_2025],
    },
    [AddonPackType.MULTI_CURRENCY]: {
        name: "Multi Currency",
        icon: <DollarOutlined />,
        min: 0,
        max: 1,
        unit: t`unit`,
        showBillingCycle: false,
        hideInPlans: [PlanType.BASE_2025, PlanType.LAUNCH_2025, PlanType.PRIME_2025, PlanType.ELITE_2025],
    },
};
